import styled from 'styled-components'

import { Banner } from 'components/Banner/Banner'
import { Typography } from 'components/Typography/Typography'
import { useGlobalBanner } from 'utils/useGlobalBanner'
import { parseMarkdownLinks } from 'utils/parseMarkdownLinks'
import { useIsMobile } from 'utils/useIsMobile'

const GLOBAL_BANNER_CONTENT_HEIGHT = 56

// GLOBAL_BANNER_CONTENT_HEIGHT + borders
export const GLOBAL_BANNER_HEIGHT = 58

const FixedBannerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
`

const GlobalBannerContainer = styled(Banner)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const GlobalBanner = () => {
  const { isEnabled, payload } = useGlobalBanner()
  const isMobile = useIsMobile()

  if (!isEnabled || !payload) {
    return null
  }

  return (
    <FixedBannerWrapper>
      <GlobalBannerContainer variant={payload.variant} style={{ width: 'auto', height: GLOBAL_BANNER_CONTENT_HEIGHT }}>
        <Typography variant={isMobile ? 'caption2' : 'body'} style={{ textAlign: 'center' }}>
          {parseMarkdownLinks(payload.message)}
        </Typography>
      </GlobalBannerContainer>
    </FixedBannerWrapper>
  )
}
